import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=1cd8a63c"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"
import style0 from "./Education.vue?vue&type=style&index=0&id=1cd8a63c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports